import { FC, PropsWithChildren, ReactNode } from 'react';

import { Stack, Typography } from 'libs/ui';

import {
  ContentStyled,
  OverrideStyles,
  WrapperStyled,
} from './OnboardingStatusWrapper.styles';

export type OnboardingStatusViewWrapperProps = {
  title: string;
  subtitle: ReactNode | ReactNode[];
  className?: string;
};

export const OnboardingStatusWrapper: FC<
  OnboardingStatusViewWrapperProps & PropsWithChildren
> = ({ children, title, subtitle, className }) => (
  <WrapperStyled className={className}>
    <OverrideStyles />
    <ContentStyled variant="filled">
      <Stack spacing={32}>
        <Stack spacing={32} spacingMobile={12}>
          <Typography
            as="h1"
            datax="onboardingStatus-title"
            variant="title"
            variantMobile="subtitle"
          >
            {title}
          </Typography>
          <Typography datax="onboardingStatus-text" whiteSpace="pre-wrap">
            {subtitle}
          </Typography>
        </Stack>
        {children}
      </Stack>
    </ContentStyled>
  </WrapperStyled>
);
